// extracted by mini-css-extract-plugin
export default {"base":"vp_iBo2D","indicator":"vp_oSAay","percent":"vp_sEdXY"};